import React, { useState } from "react";
import './Contactus.css'
import contactusimage from '../../assets/Contactus/contactusimage.png'
import help1 from '../../assets/Contactus/help1.png'
import help2 from '../../assets/Contactus/help2.png'
import help3 from '../../assets/Contactus/help3.png'
import contactimage from '../../assets/Contactus/contact-image.png'
import mapimage from '../../assets/Contactus/mapimage.png'

const ContactUs = () =>{

    const [embadedmap , setEmbadedMap] = useState("https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d927758.037296973!2d46.16298689342847!3d24.724997714854247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1758802394874!5m2!1sen!2sin")

    const showmapRiyadhHq = () =>{
        setEmbadedMap("https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d927758.037296973!2d46.16298689342847!3d24.724997714854247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1758802394874!5m2!1sen!2sin")
    }

    const showmapKhobarBranch = () =>{
        setEmbadedMap('https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d28617.446459658197!2d50.179823896079576!3d26.288237985649513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sKhobar%20Branch!5e0!3m2!1sen!2sin!4v1758802755912!5m2!1sen!2sin')
    }

    return(
        <>
           {/* <div className="contactus-section-main-container">
                <img src={contactusimage} alt="projects" className="ongoing-project-home-image"/>
                <h1 className="projects-main-heading">Let's Connect</h1>
                <p className="contactus-main-content">We'd love to hear from you. Whether it's a project inquiry, partnership, or general question — our team is ready to help.</p>
            </div> */}

            <div className="contact-us-image-container">
                <div className="overlay-text-container">
                    <h1 className="about-main-heading">Let's Connect</h1>
                    <p className="about-main-description">We'd love to hear from you. Whether it's a project inquiry, partnership, or general question — our team is ready to help.</p>
                </div>
            </div>

      <div className="help-main-container">
        <h1 className="help-heading">How Can We Help You?</h1>

        <div className="help-cards-main-container">
          <div className="help-card">
            <img src={help1} alt="help-image" className="help-image" />
            <h1 className="help-card-heading">General Inquiries</h1>
            <p className="help-description">
              Ask us about projects, services, or partnerships.
            </p>
            <button className="help-button">Email Us</button>
          </div>

          <div className="help-card">
            <img src={help2} alt="help-image" className="help-image" />
            <h1 className="help-card-heading">Call Us</h1>
            <p className="help-description">
              Speak with our team directly at HQ or Branch.
            </p>
            <button className="help-button">Call Now</button>
          </div>

          <div className="help-card">
            <img src={help3} alt="help-image" className="help-image" />
            <h1 className="help-card-heading">Visit Us</h1>
            <p className="help-description">
              Meet us at our offices in Riyadh or Khobar.
            </p>
            <button className="help-button">Get Directions</button>
          </div>
        </div>
      </div>

      <div className="message-section-main-container">
        <h1 className="message-section-heading">Send Us a Message</h1>

                <div className="message-section-main-card-container">
                    <div className="message-card">
                        <div className="input-main-container">
                            <div className="input-container">
                                <label className="input-label">First Name</label>
                                <input type="text" className="input-field-container" placeholder="Joe"/>
                            </div>

                            <div className="input-container">
                                <label className="input-label">Last Name</label>
                                <input type="text" className="input-field-container" placeholder="Doe"/>
                            </div>
                        </div>

                        <div className="input-main-container">
                            <div className="input-container">
                                <label className="input-label">Email</label>
                                <input type="text" className="input-field-container" placeholder="Email"/>
                            </div>

                            <div className="input-container">
                                <label className="input-label">Phone</label>
                                <input type="text" className="input-field-container" placeholder="+91 00000 00000"/>
                            </div>
                        </div>

                        
                            <div className="input-container">
                            <label className="input-label">Subject</label>
                            <input type="text" className="input-field-container" placeholder="Subject"/>
                        </div>

                        <div className="textarea-message-container">
                        <p className="textarea-message">Message</p>
                        <textarea 
                            rows="5" 
                            cols="50"
                            placeholder="Type here..." 
                            className="input-textarea"
                        />
                        </div>

                        <div className="message-button-container">
                            <button className="message-button">Send Message</button>
                        </div>
                    </div>
                    <div className="image-section-card">
                        <img src={contactimage} alt="contact-image" className="contact-image" />
                        <h1 className="message-title">We're Here to Help</h1>
                        <p className="message-description">Our experienced team is ready to discuss your project needs and provide expert engineering solutions.</p>
                    </div> 
                </div>
            </div>

            <div className="find-us-main-container">
                <h1 className="find-us-heading">Find Us</h1>

                <div className="findus-button-container">
                    <button className="findus-button" onClick={showmapRiyadhHq}>Riyadh HQ</button>
                    <button className="findus-button" onClick={showmapKhobarBranch}>Khobar Branch</button>
                </div>

                {/* <div className="map-image-container">
                    <img src={mapimage} alt="map-image" className="map-image" />
                </div> */}

                <div className="map-container">
                        <iframe src={embadedmap}
                            width="100%"
                            height="450px"
                            style={{border:0,borderRadius:"22px"}}
                            allowFullScreen=''
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="google-map"
                        >

                        </iframe>
                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d927758.037296973!2d46.16298689342847!3d24.724997714854247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1758802394874!5m2!1sen!2sin" width="600" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                    </div>
                </div>
    </>
  );
};

export default ContactUs;
